import ColumnBottom from './ColumnBottom';

export default ColumnBottom;
